<template>
  <v-row wrap no-gutters>
    <v-col cols="12">
      <action-select
        :key="`${step.id}-action`"
        :items="formattedFtpActions"
        :default-value="properties.action"
        step-label="ftp"
        :readonly="!canEdit"
        required
        @change="handleChange('action', $event)"
      />
    </v-col>

    <v-col cols="12">
      <v-checkbox
        :key="`${step.id}-isSftp`"
        v-model="isSftp"
        :label="$lang.labels.isSftp"
        :readonly="!canEdit"
        class="mt-0 pt-0"
      />
    </v-col>

    <credentials-select
      :key="`${step.id}-credentialName`"
      step-type="FTP"
      :properties="properties"
      :is-sftp="isSftp"
      step-label="ftp"
      :readonly="!canEdit"
      required
      @change="handleChange('credentialName', $event)"
    />

    <v-col cols="12">
      <v-text-field
        :key="`${step.id}-path`"
        v-model="properties.path"
        outlined
        dense
        :label="$lang.labels.path"
        required
        :rules="[v => !!v || $lang.labels.required]"
        :readonly="!canEdit"
        class="required-asterisk"
        data-cy="ftp-path"
      />
    </v-col>

    <v-col cols="12">
      <v-text-field
        :key="`${step.id}-targetObject`"
        v-model="properties.targetObject"
        outlined
        dense
        :label="$lang.labels.targetObject"
        required
        :rules="[v => !!v || $lang.labels.required, (v) => $options.filters.javaVariableConventionRules(v, true) || $lang.errors.variableJavaWrong]"
        :readonly="!canEdit"
        class="required-asterisk"
        data-cy="ftp-targetObject"
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import {
  ActionSelect,
  CredentialsSelect
} from './components'
import StepMixin from './StepMixin'

import { FTP_ACTIONS } from './constants'

export default {
  name: 'FTPStep',
  components: {
    ActionSelect,
    CredentialsSelect
  },
  mixins: [StepMixin],
  data() {
    return {
      isSftp: true
    }
  },
  computed: {
    formattedFtpActions() {
      return FTP_ACTIONS.map((x) => {
        return { text: this.$lang.status[x], value: x }
      })
    }
  },
  created() {
    if (!this.properties.action) this.properties.action = 'DOWNLOAD'
  }
}
</script>
